import React from "react";
import { useI18n } from "../i18n";

const LABELS: Record<string, string> = { en: "EN", ja: "日本語" };

interface LanguageSwitcherProps {
  className?: string;
}

export default function LanguageSwitcher({ className = "" }: LanguageSwitcherProps) {
  const { lang, setLang, available } = useI18n();
  return (
    <div className={`inline-flex items-center gap-1 text-sm ${className}`}>
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value)}
        className="bg-transparent border border-gray-200 rounded px-2 py-1 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-pink-400"
        aria-label="Language"
      >
        {available.map((code) => (
          <option key={code} value={code}>
            {LABELS[code] || code}
          </option>
        ))}
      </select>
    </div>
  );
}
